import { Checkbox, FormControlLabel } from '@mui/material';

import type { NoTherapyCheckboxProps } from './types';

export default function NoTherapyCheckbox({
  checked,
  disabled = false,
  onChange,
}: NoTherapyCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="No historical therapy"
    />
  );
}
